import { Outlet } from 'react-router-dom';
import { Sidebar, type SidebarItem } from './Sidebar';

interface SidebarLayoutProps {
  items: SidebarItem[];
  title: string;
  subtitle?: string;
  roleIndicator?: string;
  headerSlot?: React.ReactNode;
}

export function SidebarLayout({ items, title, subtitle, roleIndicator, headerSlot }: SidebarLayoutProps) {
  return (
    <div className="min-h-screen">
      <Sidebar
        items={items}
        title={title}
        subtitle={subtitle}
        roleIndicator={roleIndicator}
        headerSlot={headerSlot}
      />
      <main className="lg:pl-64 pt-14 lg:pt-0 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
